/* =============================================================================
   pl-v7.js — pestañas que cambian solas + deslizar sobre la imagen
   (el cambio y su animación los hace initTabs de pl-secciones.js al recibir el clic)
   ========================================================================== */
(function () {
  'use strict';
  function init(root) {
    (root || document).querySelectorAll('[data-pl-tabs]').forEach(function (box) {
      if (box._auto) return; box._auto = true;
      var btns = box.querySelectorAll('.plt__btn'); if (btns.length < 2) return;
      var secs = Number(box.getAttribute('data-auto')) || 0, touched = false, visible = false;
      var cur = function () { for (var i = 0; i < btns.length; i++) if (btns[i].classList.contains('is-on')) return i; return 0; };
      var go = function (d) { btns[(cur() + d + btns.length) % btns.length].click(); };
      box.addEventListener('pointerdown', function () { touched = true; }, { passive: true });
      // deslizar sobre la imagen cambia de beneficio
      var panels = box.querySelector('.plt__panels'), x0 = null;
      if (panels) {
        panels.addEventListener('pointerdown', function (e) { x0 = e.clientX; });
        panels.addEventListener('pointerup', function (e) {
          if (x0 === null) return; var dx = e.clientX - x0; x0 = null;
          if (Math.abs(dx) > 50) go(dx < 0 ? 1 : -1);
        });
      }
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }, { threshold: 0.5 }).observe(box);
      if (secs > 0) setInterval(function () { if (visible && !touched && !document.hidden) go(1); }, secs * 1000);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* reseñas filtrables por síntoma: oculta las tarjetas que no mencionan las palabras del filtro */
(function () {
  function init(root) {
    (root || document).querySelectorAll('[data-plr-filt]').forEach(function (bar) {
      if (bar._ok) return; bar._ok = true;
      var sec = bar.closest('section'), cards = sec.querySelectorAll('.plr__card');
      var unicas = sec.querySelector('.pcol--2') ? sec.querySelectorAll('.pcol--2 .plr__card').length / 2 : cards.length; // las columnas repiten cada tarjeta 2 veces
      var casa = function (card, f) { if (!f) return true; var t = card.textContent.toLowerCase(); return f.split(',').some(function (w) { w = w.trim(); return w && t.indexOf(w) >= 0; }); };
      bar.querySelectorAll('button').forEach(function (b) {
        var f = b.getAttribute('data-f'), n = 0;
        cards.forEach(function (c) { if (casa(c, f)) n++; });
        n = Math.round(n * unicas / cards.length);
        if (f && !n) { b.hidden = true; return; }
        b.insertAdjacentHTML('beforeend', ' <small>' + n + '</small>');
      });
      bar.addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b) return;
        bar.querySelectorAll('button').forEach(function (x) { x.classList.toggle('is-on', x === b); });
        var f = b.getAttribute('data-f');
        cards.forEach(function (c) { c.classList.toggle('is-off', !casa(c, f)); });
        if (window.anime) anime.animate(sec.querySelectorAll('.plr__card:not(.is-off)'), { opacity: [0, 1], y: [14, 0], duration: 450, delay: anime.stagger(30, { from: 'first' }), ease: 'outQuad' });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* fecha estimada de llegada: hoy + días hábiles de preparación + días de envío */
(function () {
  function sumaHabiles(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; } return d; }
  function init(root) {
    // notas marcadas: justo encima del botón de compra (Kaching mete sus packs entre los bloques del hero)
    (root || document).querySelectorAll('[data-pegar-boton]').forEach(function (el) {
      var sec = el.closest('[data-product-section]'), btn = sec && sec.querySelector('.pb-buy__main'), caja = el.closest('.pb');
      var pegar = function () { if (btn && caja && btn.previousElementSibling !== caja) btn.parentNode.insertBefore(caja, btn); };
      pegar(); window.addEventListener('load', pegar); setTimeout(pegar, 2500);
    });
    (root || document).querySelectorAll('[data-entrega]').forEach(function (el) {
      var v = el.getAttribute('data-entrega').split(',').map(Number), hoy = new Date();
      var f = function (proc, envio) { var d = sumaHabiles(hoy, proc); d.setDate(d.getDate() + envio); return d.toLocaleDateString('es-MX', { weekday: 'short', day: 'numeric', month: 'short' }).replace(/\./g, '').replace(' de ', ' '); };
      var b = el.querySelector('[data-fecha]'); if (b) b.textContent = 'entre el ' + f(v[0], v[2]) + ' y el ' + f(v[1], v[3]);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
